import React from 'react';

const FormFileInput = ({ label, register, name, rules, errors, accept, hint }) => {
    const error = errors[name];

    return (
        <div className="flex flex-col mb-4">
            <label htmlFor={name} className="mb-1 text-sm font-medium text-gray-700">
                {label} {rules?.required && <span className="text-red-500">*</span>}
            </label>
            <input
                id={name}
                type="file"
                accept={accept}
                className={`block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 border rounded-md shadow-sm ${error ? 'border-red-500' : 'border-gray-300'
                    }`}
                {...register(name, rules)}
            />
            {hint && !error && <span className="mt-1 text-xs text-gray-500">{hint}</span>}
            {error && (
                <span className="mt-1 text-xs text-red-500">{error.message}</span>
            )}
        </div>
    );
};

export default FormFileInput;